var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChessWhiteK(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 888 945",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-52,-22)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.10867,0,0,1.10867,-53.8917,-34.8603)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "chess_whiteK",
    d: "M532,72L451,72L451,132L385,133L386,222L451,222L453,325C453,325 387.803,274.934 299,278C210.197,281.066 112.133,343.692 117,473C121.867,602.308 233.683,730.664 293,768C277.915,768.329 285.476,771.572 247,771C197.54,770.264 193.684,880.566 250,882C306.316,883.434 689.894,880.883 740,881C800.093,881.141 794.784,775.351 740,776C705.248,776.412 724.964,777.566 687,777C792.527,698.455 874.991,577.769 875,479C875.009,380.231 806.501,274.433 695,281C583.499,287.567 535,325 535,325C534.4,292.955 533,222 533,222L602,222L601,132L532,132L532,72Z",
    style: {
      fill: "white",
      stroke: "black",
      strokeWidth: "41.34px"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChessWhiteK);
export default __webpack_public_path__ + "static/media/chess_whiteK.8c97fed76bd570254dbea4033676b6e7.svg";
export { ForwardRef as ReactComponent };